import { api } from "../api";

export type VehicleCustomerTransferRequestType = {
    sourceCustomerId: number;
    vehicleIds: Array<number>;
    targetCustomerId: number;
    targetDepartmentId: number;
    justification: string;
};

/**
 * transferVehiclesToCustomer - Function that transfers vehicles from one customer to another (admin only)
 * /vehicles/customer-transfers
 * method POST
 * @async-function
 */
const transferVehiclesToCustomer = async (token: string, model: VehicleCustomerTransferRequestType) => {
    const response = await api.post(
        `/vehicles/customer-transfers`, { ...model }, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    return response;
};

export default transferVehiclesToCustomer;
